
import { Link, useLocation, useParams } from 'react-router-dom';

export default function Breadcrumb() {
  const location = useLocation();
  const params = useParams();
  
  const pathMap: { [key: string]: string } = {
    '/': 'Home',
    '/staff': 'Staff',
    '/news': 'News',
  };

  // ニュース記事のデータ
  const newsItems = [
    {
      id: 1,
      title: '新年のご挨拶と営業時間のお知らせ',
    },
    {
      id: 2,
      title: '新メニュー「プレミアムトリートメント」開始',
    },
    {
      id: 3,
      title: 'スタッフ募集のお知らせ',
    },
    {
      id: 4,
      title: '年末年始の営業時間について',
    },
    {
      id: 5,
      title: '冬の限定メニューのご案内',
    },
    {
      id: 6,
      title: '年末のご予約について',
    },
    {
      id: 7,
      title: 'ヘアケア商品の販売開始',
    },
    {
      id: 8,
      title: 'クリスマス限定ヘアセットメニュー',
    }
  ];

  if (location.pathname === '/') return null;

  // ニュース詳細ページの場合
  if (location.pathname.startsWith('/news/') && params.id) {
    const newsItem = newsItems.find(item => item.id === Number(params.id));
    const newsTitle = newsItem ? newsItem.title : 'お知らせ詳細';

    return (
      <nav className="bg-white border-b border-gray-200 py-3">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center space-x-2 text-sm">
            <Link to="/" className="text-gray-600 hover:text-black transition-colors">
              Home
            </Link>
            <span className="text-gray-400">/</span>
            <Link to="/news" className="text-gray-600 hover:text-black transition-colors">
              News
            </Link>
            <span className="text-gray-400">/</span>
            <span className="text-black font-medium">
              {newsTitle}
            </span>
          </div>
        </div>
      </nav>
    );
  }

  return (
    <nav className="bg-white border-b border-gray-200 py-3">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center space-x-2 text-sm">
          <Link to="/" className="text-gray-600 hover:text-black transition-colors">
            Home
          </Link>
          <span className="text-gray-400">/</span>
          <span className="text-black font-medium">
            {pathMap[location.pathname] || 'Page'}
          </span>
        </div>
      </div>
    </nav>
  );
}
